import { List, ListItem, Stack, TextField, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useGetPackSummaryQuery, useUpdatePackReviewsMutation } from '../../../../api/apiSlice';
import { LoadingButton } from '@mui/lab';
import LoadingIndicator from '../../../LoadingIndicator';

function PackUsageForm({ pack }) {
    const { data: packData = {}, isLoading, isSuccess } = useGetPackSummaryQuery(pack.id);
    const [updatePackReviews] = useUpdatePackReviewsMutation();
    
    const [physicians, setPhysicians] = useState([]);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (isSuccess && packData.physicians) {
            const physiciansWithUsage = Object.values(packData.physicians).map(physician => ({
                ...physician,
                pack_usage: physician.pack_usage || 0
            }));
            setPhysicians(physiciansWithUsage);
        }
    }, [isSuccess, packData]);

    async function handleSave() {
        setIsSaving(true);
        await Promise.all(physicians.map(async element => {
            await updatePackReviews({
                cardOwnerId: element.id,
                packReviewId: element.pack_review_id,
                reviewData: { pack_usage_percentage: parseFloat(element.pack_usage) }
            });
        }));
        setIsSaving(false);
    }

    return (
        <Stack p={4} spacing={4} boxShadow={2} backgroundColor='white' borderRadius='8px'>
            <Typography variant='heavy' fontSize='20px'>Pack Usage Percentages</Typography>
            {isLoading && <LoadingIndicator />}
            {isSuccess && (
                <Stack spacing={1}>
                    <Typography variant='heavy' fontSize='16px'>Please enter pack usage data for {packData.name}</Typography>
                    <Typography variant='light' fontSize='12px'>Please enter a decimal for each physician between 0 and 1 (e.g. 0.25 for 25%)</Typography>
                    <List>
                        {physicians.map(physician => (
                            <ListItem key={physician.id}>
                                <Stack direction="row" alignItems='center' spacing={2}>
                                    <Typography>{physician.first_name + ' ' + physician.last_name}:</Typography>
                                    <TextField 
                                        value={physician.pack_usage}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setPhysicians(prevPhysicians => prevPhysicians.map(p => 
                                                p.id === physician.id ? { ...p, pack_usage: newValue } : p
                                            ));
                                        }}
                                        size='small'
                                    />
                                    <Typography>({parseFloat(physician.pack_usage * 100).toFixed(2)}%)</Typography>
                                </Stack>
                            </ListItem>
                        ))}
                        <ListItem>
                            <Typography>Total: {(physicians.reduce((acc, physician) => acc + (parseFloat(physician.pack_usage) ?? 0), 0) * 100).toFixed(2)}%</Typography>    
                        </ListItem>
                        <LoadingButton variant='contained' onClick={handleSave} loading={isSaving}>
                            Save Pack Usage
                        </LoadingButton>
                    </List>
                </Stack>
            )}
        </Stack>
    );
}

export default PackUsageForm;
